import { createAction, createReducer } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import { RequestStatus } from '../../types/type'

export type AddressState = {
    autocomplete?: any,
    place: RequestStatus,
    trees: RequestStatus,
    satellite: RequestStatus,
    streetViews: RequestStatus,
    historicMonuments: RequestStatus,
    fireStations: RequestStatus,
    gasStations: RequestStatus,
    waterWays: RequestStatus
    railRoads: RequestStatus
}

const initialState: AddressState = {
    autocomplete: undefined,
    place: {
        status: 'idle',
        value: undefined,
        error: undefined
    },
    trees: {
        status: 'idle',
        value: undefined,
        error: undefined
    },
    satellite: {
        status: 'idle',
        value: undefined,
        error: undefined
    },
    streetViews: {
        status: 'idle',
        value: undefined,
        error: undefined
    },
    historicMonuments: {
        status: 'idle',
        value: undefined,
        error: undefined
    },
    fireStations: {
        status: 'idle',
        value: undefined,
        error: undefined
    },
    gasStations: {
        status: 'idle',
        value: undefined,
        error: undefined
    },
    waterWays: {
        status: 'idle',
        value: undefined,
        error: undefined
    },
    railRoads: {
        status: 'idle',
        value: undefined,
        error: undefined
    }
}

export const setAutoCompleteValue = createAction('address/autocomplete', function prepare(place_id: string) {
    return {
        payload: {
            place_id
        },
    }
}) as any

export const fetchAddressAction = createAction('address/fetch', function prepare(place_id: string) {
    return {
        payload: {
            place_id
        },
    }
}) as any
fetchAddressAction.pending = createAction('address/fetch/pending')

/** Fetch address by map click coordinates; same result as fetchAddressAction (place + related data). */
export const fetchAddressByCoordinatesAction = createAction('address/fetchByCoordinates', function prepare(lat: number, lng: number) {
    return {
        payload: { lat, lng },
    }
}) as any

fetchAddressAction.fulfilled = createAction('address/fetch/fulfilled', function prepare(address: any) {
    return {
        payload: {
            address
        }
    }
})
fetchAddressAction.rejected = createAction('address/fetch/rejected', function prepare(error: any) {
    return {
        payload: {
            error
        }
    }
})

export const fetchTreesAction = createAction('address/trees/fetch', function prepare(place_id: string, distance?: number) {
    return {
        payload: {
            place_id,
            distance
        },
    }
}) as any
fetchTreesAction.pending = createAction('address/trees/fetch/pending')
fetchTreesAction.fulfilled = createAction('address/trees/fetch/fulfilled', function prepare(trees: any) {
    return {
        payload: {
            trees
        }
    }
})
fetchTreesAction.rejected = createAction('address/trees/fetch/rejected', function prepare(error: any) {
    return {
        payload: {
            error
        }
    }
})

export const fetchSatelliteImageAction = createAction('address/satellite/fetch', function prepare(place_id: string) {
    return {
        payload: {
            place_id
        },
    }
}) as any
fetchSatelliteImageAction.pending = createAction('address/satellite/fetch/pending')
fetchSatelliteImageAction.fulfilled = createAction('address/satellite/fetch/fulfilled', function prepare(satelliteImage: any, zoomLevel: number, fetchedDate: string) {
    return {
        payload: {
            satelliteImage,
            zoomLevel,
            fetchedDate
        }
    }
})
fetchSatelliteImageAction.rejected = createAction('address/satellite/fetch/rejected', function prepare(error: any) {
    return {
        payload: {
            error
        }
    }
})

export const fetchStreetViewImagesAction = createAction('address/street-views/fetch', function prepare(place_id: string) {
    return {
        payload: {
            place_id
        },
    }
}) as any
fetchStreetViewImagesAction.pending = createAction('address/street-views/fetch/pending')
fetchStreetViewImagesAction.fulfilled = createAction('address/street-views/fetch/fulfilled', function prepare(streetViewImages: any) {
    return {
        payload: {
            streetViewImages
        }
    }
})
fetchStreetViewImagesAction.rejected = createAction('address/street-views/fetch/rejected', function prepare(error: any) {
    return {
        payload: {
            error
        }
    }
})

export const fetchWaterWaysAction = createAction('address/water-ways/fetch', function prepare(place_id: string, distance?: number) {
    return {
        payload: {
            place_id,
            distance
        },
    }
}) as any
fetchWaterWaysAction.pending = createAction('address/water-ways/fetch/pending')
fetchWaterWaysAction.fulfilled = createAction('address/water-ways/fetch/fulfilled', function prepare(waterWays: any) {
    return {
        payload: {
            waterWays
        }
    }
})
fetchWaterWaysAction.rejected = createAction('address/water-ways/fetch/rejected', function prepare(error: any) {
    return {
        payload: {
            error
        }
    }
})

export const fetchRailRoadsAction = createAction('address/rail-roads/fetch', function prepare(place_id: string, distance?: number) {
    return {
        payload: {
            place_id,
            distance
        },
    }
}) as any
fetchRailRoadsAction.pending = createAction('address/rail-roads/fetch/pending')
fetchRailRoadsAction.fulfilled = createAction('address/rail-roads/fetch/fulfilled', function prepare(railRoads: any) {
    return {
        payload: {
            railRoads
        }
    }
})
fetchRailRoadsAction.rejected = createAction('address/rail-roads/fetch/rejected', function prepare(error: any) {
    return {
        payload: {
            error
        }
    }
})

export const fetchHistoricMonumentsAction = createAction('address/historic-monuments/fetch', function prepare(place_id: string, distance?: number) {
    return {
        payload: {
            place_id,
            distance
        },
    }
}) as any
fetchHistoricMonumentsAction.pending = createAction('address/historic-monuments/fetch/pending')
fetchHistoricMonumentsAction.fulfilled = createAction('address/historic-monuments/fetch/fulfilled', function prepare(historicMonuments: any) {
    return {
        payload: {
            historicMonuments
        }
    }
})
fetchHistoricMonumentsAction.rejected = createAction('address/historic-monuments/fetch/rejected', function prepare(error: any) {
    return {
        payload: {
            error
        }
    }
})

export const fetchFireStationsAction = createAction('address/fire-stations/fetch', function prepare(place_id: string) {
    return {
        payload: {
            place_id
        },
    }
}) as any
fetchFireStationsAction.pending = createAction('address/fire-stations/fetch/pending')
fetchFireStationsAction.fulfilled = createAction('address/fire-stations/fetch/fulfilled', function prepare(fireStations: any) {
    return {
        payload: {
            fireStations
        }
    }
})
fetchFireStationsAction.rejected = createAction('address/fire-stations/fetch/rejected', function prepare(error: any) {
    return {
        payload: {
            error
        }
    }
})

export const fetchGasStationsAction = createAction('address/gas-stations/fetch', function prepare(place_id: string) {
    return {
        payload: {
            place_id
        },
    }
}) as any
fetchGasStationsAction.pending = createAction('address/gas-stations/fetch/pending')
fetchGasStationsAction.fulfilled = createAction('address/gas-stations/fetch/fulfilled', function prepare(gasStations: any) {
    return {
        payload: {
            gasStations
        }
    }
})
fetchGasStationsAction.rejected = createAction('address/gas-stations/fetch/rejected', function prepare(error: any) {
    return {
        payload: {
            error
        }
    }
})


export const selectAutoComplete = (state: RootState) => state.address.autocomplete;
export const selectAddress = (state: RootState) => state.address.place;
export const selectTrees = (state: RootState) => state.address.trees;
export const selectSatelliteImage = (state: RootState) => state.address.satellite;
export const selectStreetViewImages = (state: RootState) => state.address.streetViews;
export const selectHistoricMonuments = (state: RootState) => state.address.historicMonuments;
export const selectFireStations = (state: RootState) => state.address.fireStations;
export const selectGasStations = (state: RootState) => state.address.gasStations;
export const selectWaterWays = (state: RootState) => state.address.waterWays;
export const selectRailRoads = (state: RootState) => state.address.railRoads;

export default createReducer(initialState, (builder) => {
    builder.addCase(setAutoCompleteValue, (state, action) => {
        state.autocomplete = action.payload.place_id
    })
    // builder.addCase(fetchAddressAction, (state, action) => {
    //     state = initialState
    // })
    builder.addCase(fetchAddressAction.pending, (state, action) => {
        state.place.status = 'loading'
        state.place.error = undefined
    })
    builder.addCase(fetchAddressAction.fulfilled, (state, action) => {
        state.place.status = 'idle';
        state.place.value = action.payload.address
    })
    builder.addCase(fetchAddressAction.rejected, (state, action) => {
        state.place.status = 'failed';
        state.place.error = action.payload.error
    })

    builder.addCase(fetchTreesAction.pending, (state) => {
        state.trees.status = 'loading'
        state.trees.value = undefined
        state.trees.error = undefined
    })
    builder.addCase(fetchTreesAction.fulfilled, (state, action) => {
        state.trees.status = 'idle'
        state.trees.value = action.payload.trees
    })
    builder.addCase(fetchTreesAction.rejected, (state, action) => {
        state.trees.status = 'failed'
        state.trees.error = action.payload.error
    })

    // builder.addCase(fetchSateliteImageAction, (state, action) => {
    //     state.satellitImage = initialState.satellitImage
    // })
    builder.addCase(fetchSatelliteImageAction.pending, (state, action) => {
        state.satellite.status = 'loading'
    })
    builder.addCase(fetchSatelliteImageAction.fulfilled, (state, action) => {
        state.satellite.status = 'idle';
        state.satellite.value = action.payload
    })
    builder.addCase(fetchSatelliteImageAction.rejected, (state, action) => {
        state.satellite.status = 'failed';
        state.satellite.error = action.payload.error
    })

    // builder.addCase(fetchStreetViewImagesAction, (state, action) => {
    //     state.streetViewImages = initialState.streetViewImages
    // })
    builder.addCase(fetchStreetViewImagesAction.pending, (state, action) => {
        state.streetViews.status = 'loading'
    })
    builder.addCase(fetchStreetViewImagesAction.fulfilled, (state, action) => {
        state.streetViews.status = 'idle';
        state.streetViews.value = action.payload.streetViewImages
    })
    builder.addCase(fetchStreetViewImagesAction.rejected, (state, action) => {
        state.streetViews.status = 'failed';
        state.streetViews.error = action.payload.error
    })

    // builder.addCase(fetchHistoricMonumentsAction, (state, action) => {
    //     state.historicMonuments = initialState.historicMonuments
    // })
    builder.addCase(fetchHistoricMonumentsAction.pending, (state, action) => {
        state.historicMonuments.status = 'loading'
    })
    builder.addCase(fetchHistoricMonumentsAction.fulfilled, (state, action) => {
        state.historicMonuments.status = 'idle';
        state.historicMonuments.value = action.payload.historicMonuments
    })
    builder.addCase(fetchHistoricMonumentsAction.rejected, (state, action) => {
        state.historicMonuments.status = 'failed';
        state.historicMonuments.error = action.payload.error
    })

    builder.addCase(fetchFireStationsAction.pending, (state) => {
        state.fireStations.status = 'loading'
        state.fireStations.value = undefined
        state.fireStations.error = undefined
    })
    builder.addCase(fetchFireStationsAction.fulfilled, (state, action) => {
        state.fireStations.status = 'idle';
        state.fireStations.value = action.payload.fireStations
    })
    builder.addCase(fetchFireStationsAction.rejected, (state, action) => {
        state.fireStations.status = 'failed';
        state.fireStations.error = action.payload.error
    })

    builder.addCase(fetchGasStationsAction.pending, (state) => {
        state.gasStations.status = 'loading'
        state.gasStations.value = undefined
        state.gasStations.error = undefined
    })
    builder.addCase(fetchGasStationsAction.fulfilled, (state, action) => {
        state.gasStations.status = 'idle';
        state.gasStations.value = action.payload.gasStations
    })
    builder.addCase(fetchGasStationsAction.rejected, (state, action) => {
        state.gasStations.status = 'failed';
        state.gasStations.error = action.payload.error
    })

    builder.addCase(fetchWaterWaysAction.pending, (state, action) => {
        state.waterWays.status = 'loading'
    })
    builder.addCase(fetchWaterWaysAction.fulfilled, (state, action) => {
        state.waterWays.status = 'idle';
        state.waterWays.value = action.payload.waterWays
    })
    builder.addCase(fetchWaterWaysAction.rejected, (state, action) => {
        state.waterWays.status = 'failed';
        state.waterWays.error = action.payload.error
    })

    builder.addCase(fetchRailRoadsAction.pending, (state, action) => {
        state.railRoads.status = 'loading'
    })
    builder.addCase(fetchRailRoadsAction.fulfilled, (state, action) => {
        state.railRoads.status = 'idle';
        state.railRoads.value = action.payload.railRoads
    })
    builder.addCase(fetchRailRoadsAction.rejected, (state, action) => {
        state.railRoads.status = 'failed';
        state.railRoads.error = action.payload.error
    })
})
